import $ from 'jquery';
import TipsAndBenefitsView from '../views/TipsAndBenefitsView';
import TipsAndBenefits from '../models/TipsAndBenefits';
const carouselImageWidth = 306;
import Hammer from 'hammerjs';
import action from '../action';

function start(context) {
  var params = TipsAndBenefits.init(context);
  TipsAndBenefitsView.render({params});
  bindEvents(params);
}
function refresh(back){
  var params = TipsAndBenefits.getOfferdata();
  if(!back){
    TipsAndBenefits.saveState();
  }
  TipsAndBenefitsView.render({params});
  bindEvents(params);
}
function bindEvents(params){

  $('.tips__container').scrollTop(params.scrollposition);

  $( '.tips__container' ).scroll(function() {
    var scrollPosition = $(this).scrollTop();
    TipsAndBenefits.setPosition(scrollPosition);
  });

  $('img').on('dragstart', function(){
    return false;
  });

  $('.tips .items').on('click', '.item', event => {
    const id = $(event.currentTarget).attr('id');
    const [, storeid] = id.split('-');
    TipsAndBenefits.updateState();
    TipsAndBenefits.updateLastPosition($('.tips__container').scrollTop());
    storeid && action.showStoreInfo(storeid);
  });

  $('#backbutton').on('click', function(e){
    e.stopPropagation();
    var doRefresh = TipsAndBenefits.goBack();
    if(doRefresh){
      refresh('back');
    }
  });
  $('.showby').on('mouseup touchend', function(){
    TipsAndBenefits.updateState();
    TipsAndBenefits.toggleShowByCategory();
    refresh();
  });
  $('.cat').on('mouseup touchend', function(){
    TipsAndBenefits.toggleShowByCategory();
    TipsAndBenefits.setCategory(this.id);
    refresh();
  });
  $('.list__item').on('mouseup touchend', function(){
    TipsAndBenefits.toggleShowByCategory();
    var [categoryid, storeid] = this.id.split('-');
    TipsAndBenefits.setOffersByStore(storeid);
    refresh();
  });
}

export default {
  start,
  bindEvents
};
